//import { NgModule } from '@angular/core';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA }      from '@angular/core'; 
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { HOME_ROUTE } from './home.route';
import { HomeComponent } from './home.component';

// Dependency
import {MatMenuModule} from '@angular/material/menu';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCardModule} from '@angular/material/card';



@NgModule({
  imports: [SharedModule, RouterModule.forChild([HOME_ROUTE]),MatMenuModule,CdkAccordionModule,MatTabsModule,MatCardModule],
  declarations: [HomeComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeModule {

}
